import { useSelector } from 'react-redux';
import commonStrings from 'modules/labs/common/strings';
import logo from 'assets/images/logo.png';
import PropTypes from 'prop-types';
import SectionDivider from '../SectionDivider';
import {
  SidebarWrapper,
  SidebarLogoWrapper,
  SidebarLogo,
  SidebarItemContainer,
  SidebarItemWrapper,
  SidebarItem,
} from './Sidebar.style';
import SidebarLink from './SidebarItemLink';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################

const Sidebar = props => {
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const context = useSelector(state => state.common.context);
  const { sidebarItems } = props;
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <SidebarWrapper>
      <SidebarLogoWrapper>
        <SidebarLogo src={logo} alt={commonStrings.sidebar.logoImageAltText} />
      </SidebarLogoWrapper>
      {sidebarItems?.map(sidebarItem => {
        const isItemSelected = sidebarItem.context === context;
        return (
          <SidebarItemContainer key={sidebarItem.name} pushToEnd={sidebarItem.pushToEnd}>
            <SidebarLink sidebarItem={sidebarItem}>
              <SidebarItemWrapper icon={sidebarItem.icon} selected={isItemSelected}>
                {sidebarItem.name && (
                  <>
                    <SectionDivider gap={6} />
                    <SidebarItem>{sidebarItem.name}</SidebarItem>
                  </>
                )}
              </SidebarItemWrapper>
            </SidebarLink>
          </SidebarItemContainer>
        );
      })}
    </SidebarWrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

Sidebar.propTypes = {
  sidebarItems: PropTypes.arrayOf(
    PropTypes.shape({
      context: PropTypes.string,
      icon: PropTypes.string,
      name: PropTypes.string,
      pushToEnd: PropTypes.bool,
    }),
  ),
};

Sidebar.defaultProps = {
  sidebarItems: [],
};

export default Sidebar;
